import React, { FC, useState } from 'react'
import SALink from 'components/SALink'
import { stripScriptTags } from 'lib/sanitize'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'
import Collection from './artworks/List'
import styles from './shows.module.scss'

const ShowDetail: FC<ListProps> = (props) => {
  const { showData } = props
  const { heroImage, brandIcon, brandUrl, detailCopy, title, subTitle } = showData
  // Split detailCopy into an array on line breaks '/n/r'.
  // We'll map it back in below with proper <p> tags.
  const copyArray = detailCopy.split('/n/n')
  const [shouldShowMore, setShouldShowMore] = useState(true)
  return (
    <div className={styles.wrapper}>
      <div className={styles.showDetail}>
        <div className={styles.hero}>
          <div className={styles.heroImage} style={{ backgroundImage: `url(${heroImage})` }}>
            <div>
              <h1>{title}</h1>
              <h2>{subTitle}</h2>
            </div>
          </div>
        </div>

        <div className={styles.content}>
          <SALink href={brandUrl} data-type='brandIcon'>
            <img src={brandIcon} />
          </SALink>

          <div className={styles.copy}>
            {copyArray.map((item, index) => {
              const cleanItem = stripScriptTags(item)

              if (shouldShowMore && index > 0) {
                return null
              }

              return (
                <p
                  key={index}
                  dangerouslySetInnerHTML={{
                    __html: cleanItem,
                  }}
                />
              )
            })}
          </div>

          {copyArray.length > 1 && (
            <button
              type='button'
              data-type='readMore'
              onClick={() => setShouldShowMore(!shouldShowMore)}
            >
              {shouldShowMore ? 'Read more' : 'Read less'}
            </button>
          )}
        </div>
        <Collection />
      </div>
    </div>
  )
}

export default ListConnector(ShowDetail)
